export const progressData = [
  {
    title: "Start Journey",
    desp: "You are just 2 minutes ⏳ away from getting JobReadyPro (our Premium Placement Preparation Platform) 100% FREE of cost! \n\nHurry, complete the steps and claim your rewards! 🎉🎁",
    showTextField: false,
  },
  {
    title: "Send WhatsApp message",
    desp: "Copy the whatsapp message given below and send it to your class whatsapp group 📲, once done upload a screenshot proof 📸 of the message being delivered to your class whatsapp group.",
    showTextField: true,
    checkpoint: "LP1",
    link: "https://docs.google.com/document/d/16peKexLDTYiCHUEwg2JDGpAI8FVe6vNgP4F-wP6NSw8",
    message:
      "Note: The message should be sent to class whatsapp group only and not any random group. \n\nUpload screenshot of the chat.\n\n",
  },
  {
    title: "Introducing JobReadyPro - Unlock Your Career Potential!",
    desp: "If you have completed the previous steps properly, within 4 weeks you will get an email with access to JobReadyPro! 💼✅",
    showTextField: false,
  },
  {
    title: "Post on LinkedIn",
    desp: "Post on LinkedIn to proudly boast your Job Ready Analysis 🚀📊 that you completed on our platform with appropriate screenshots (whichever you feel suitable) from your profile. 📸🌐",
    showTextField: true,
    checkpoint: "LP2",
    link: "https://docs.google.com/document/d/1QFpdjEEZi1_Mbir1Rjtt4gdN7VYK_ZNSadIyeY5CDcg",
    message: "Attach URL of the LinkedIn Post -",
  },
  {
    title: "Unlock Guaranteed Internship & Placement Opportunities",
    desp: "If you have completed the previous steps properly, within 2 weeks you will get an email with access to a Guaranteed FullStack Internship 📧👨‍💻 as well as referrals of 15+ Superdream Companies! 🌟🚀💌",
    showTextField: false,
  },
];
